import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import bannerImage from 'presentation/assets/images/eed_small.jpeg';

const EEDModalContent: React.FC<any> = () => {
  const { t } = useTranslation();
  return (
    <div className="pb-3">
      <img src={bannerImage} alt="betriebskostenabrechnung" className="mw-100 h-auto" />

      <p className="copy my-4">
        <Trans i18nKey="eedModalDesc" tOptions={{ skipPostProcessing: true }} />
      </p>

      <p className="copy mt-4">
        <Trans i18nKey="eedModalListTitle" tOptions={{ skipPostProcessing: true }} />
      </p>

      <ul>
        {[1, 2, 3].map((advantage) => (
          <li key={advantage} className="mb-3">
            <span className="copy">{t(`eedModalListItem${advantage}`)}</span>
          </li>
        ))}
      </ul>

      <p className="copy mt-4">
        <Trans i18nKey="eedModalContent1" tOptions={{ skipPostProcessing: true }} />
      </p>
      <p className="copy mt-4">
        <Trans i18nKey="eedModalContent2" tOptions={{ skipPostProcessing: true }} />
      </p>
      <p className="copy mt-4">
        <Trans i18nKey="eedModalContent3" tOptions={{ skipPostProcessing: true }} />
      </p>
    </div>
  );
};

export default EEDModalContent;
